export const SizeConstants = {
  BIG_TEMPLATES_SIZE: "348px",
  SMALL_TEMPLATES_SIZE: "174px",
  CLOSED_TEMPLATES_SIZE: "0px",
};
